module.exports = __webpack_public_path__ + "media/images/site/CINFANTIL_PROPOSTA_EDUCACIONAL-2abe2f8d05388b9160b19c9f21aef392.jpg";